/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Thu Jul 27 2023
 **/
import { useTheme } from "@emotion/react";

import { Icon, Row, Typography } from "@/frameworks/designStuff/components";
import * as S from "./private/emotion";

export interface ToastProps {
	status?: DesignStuff.Toast.Type;
	onClose: (ev: React.MouseEvent<SVGSVGElement>) => void;
	message: string;
	showCloseButton: boolean;
}

function StatusIcon({ status }: { status: DesignStuff.Toast.Type }) {
	const theme = useTheme();
	switch (status) {
		case "success": {
			return <Icon name="ToastSuccess24" size={24} fill={theme.colors.neutral_00_100} />;
		}
		case "info": {
			return <Icon name="ToastInfo24" size={24} fill={theme.colors.neutral_00_100} />;
		}
		case "error": {
			return <Icon name="ToastError24" size={24} fill={theme.colors.neutral_00_100} />;
		}
		case "fatal": {
			return <Icon name="ToastError24" size={24} fill={theme.colors.neutral_00_100} />;
		}
		default: {
			return null;
		}
	}
}

export default function Toast({ status = "system", message, onClose, showCloseButton }: ToastProps) {
	const theme = useTheme();

	return (
		<S.ToastWrapper verticalAlign="center" horizonAlign="distribute" status={status}>
			<Row gap={6} verticalAlign="center">
				{status !== "system" && <StatusIcon status={status} />}
				<Typography typoSize="Title1_B" typoColor="neutral_10_100" style={{ whiteSpace: "pre-line" }}>
					{message}
				</Typography>
			</Row>
			{showCloseButton && (
				<S.ActionWrapper>
					<Icon fill={theme.colors.neutral_00_68} name="Close24" size={24} onClick={onClose} />
				</S.ActionWrapper>
			)}
		</S.ToastWrapper>
	);
}
